skrilla.service('bettingReferenceService', function(paginationService){
  const eventTypes = () => [
    "MATCH", "SEASON", "TOURNAMENT", "RACE"
  ];
  const adminControlLevels = () => [
    "NONE", "STATUS_ONLY", "ALL"
  ];
  const outcomeTypes = () =>[
    "FRANCHISE", //franchise in non h2h markets e.g. outrights
    "FRANCHISE_HOME", //home franchise for h2h markets
    "FRANCHISE_AWAY", //away franchise for h2h markets
    "PLAYER", //player in non h2h markets e.g. outrights
    "PLAYER_HOME",
    "PLAYER_AWAY",
    "DRAW",
    "YES",
    "NO",
    "OVER",
    "UNDER",
    "CORRECT_SCORE",
  ];
  const marketTypes = () =>[
    "CUSTOM",
    "WINNER",
    "OUTRIGHT_WINNER",
    "OUTRIGHT_SHORT_TERM_WINNER",
    "WIN_LOSE_DRAW", //1x2
    "WILL_THERE_BE_OVERTIME",
    "FIRST_TRY_SCORER",
    "ANYTIME_TRY_SCORER",
    "TOTAL_TRIES_UNDER_OVER",
    "DISPOSALS_UNDER_OVER",
    "TOTAL_GOALS_UNDER_OVER",
    "ANYTIME_GOAL",
    "FIRST_GOAL_SCORER"
  ];

  const marketCategories = () =>[
      "Same Game Multis",
      "Promotions",
  ];

  const matchSourceTypes = () => [
    "BET_RADAR_UOF",
    "SKRILLA",
    "ODDIN",
    "RACING_AND_SPORT",
    "SPORT_CAST",
  ]

  return {
    eventTypes,
    outcomeTypes,
    marketTypes,
    adminControlLevels,
    marketCategories,
    matchSourceTypes,
  };
});

